import { render, staticRenderFns } from "./scrmProduct.vue?vue&type=template&id=4db4ba32&scoped=true"
import script from "./scrmProduct.vue?vue&type=script&lang=js"
export * from "./scrmProduct.vue?vue&type=script&lang=js"
import style0 from "./scrmProduct.vue?vue&type=style&index=0&id=4db4ba32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4ba32",
  null
  
)

export default component.exports